(() => {
  if (customElements.get('gvs-count-up')) return;

  class GVSCountUp extends HTMLElement {
    connectedCallback() {
      this.numberElement = this.querySelector('[data-gvs-count-number]');
      this.target = this.parseNumber(this.dataset.target);
      this.duration = Math.max(0, Number(this.dataset.duration) || 1200);
      this.decimals = Math.max(0, Number(this.dataset.decimals) || 0);
      this.useSeparator = this.dataset.useSeparator === 'true';
      this.enableAnimation = this.dataset.enableAnimation === 'true';
      this.hasAnimated = false;
      this.observer = null;

      if (!this.numberElement || Number.isNaN(this.target)) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.enableAnimation || reduceMotion || this.duration === 0) {
        this.setValue(this.target);
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.animate();
                this.observer.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );

        this.observer.observe(this);
      } else {
        this.animate();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }

    parseNumber(value) {
      if (typeof value !== 'string') return Number(value);
      return Number(value.replace(/,/g, '').trim());
    }

    formatNumber(value) {
      const options = {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      };

      if (!this.useSeparator) {
        return value.toFixed(this.decimals);
      }

      return new Intl.NumberFormat(undefined, options).format(value);
    }

    setValue(value) {
      this.numberElement.textContent = this.formatNumber(value);
    }

    animate() {
      if (this.hasAnimated) return;
      this.hasAnimated = true;

      const start = 0;
      const end = this.target;
      const startTime = performance.now();

      const tick = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / this.duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = start + (end - start) * easedProgress;

        this.setValue(currentValue);

        if (progress < 1) {
          this.frame = window.requestAnimationFrame(tick);
        } else {
          this.setValue(end);
        }
      };

      this.setValue(start);
      this.frame = window.requestAnimationFrame(tick);
    }
  }

  customElements.define('gvs-count-up', GVSCountUp);
})();